import { GlobalApplicationState } from 'globalApplicationState';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { Button, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import { CloseIcon } from 'tinacms';
import { DIALOG_BODY_PADDING } from 'modules/topics/styles/constants';
import MandatoryField from '../common/mandatoryField';
import TopicGroupSearch from './common/topicGroupSearch';
import { getTopicGroups, moveTopics, topicSlice } from 'modules/topics/reducer';
import { ThunkDispatch } from '@reduxjs/toolkit';

const TopicMove: React.FunctionComponent<ComponentProps> = (props) => {
    const [selectedGroupId, setSelectedGroupId] = React.useState<string | null>(null);

    const {
        topicGroups,
        isUpdating: isSaving,
        errorMessage
    } = useSelector((state: GlobalApplicationState) => state.topics);

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const handleMove = async () => {
        if (isSaving) return;
        const payload = {
            groupId: selectedGroupId ?? "",
            topics: props.topics
        }
        
        const isSuccessful = await dispatch(moveTopics(payload)).unwrap();
        if (isSuccessful) dispatch(getTopicGroups());
    };

    const getSearchField = (): JSX.Element => {
        return <TopicGroupSearch
            topicGroups={topicGroups.map(tg => ({ id: tg.id, label: tg.name }))}
            onSelect={onGroupSelect}
            errorText={errorMessage}
        />;
    };

    const onGroupSelect = (newGroup: string) => {
        dispatch(topicSlice.actions.SET_ERR_MSG(""));
        setSelectedGroupId(newGroup ?? "");
    }

    const onClose = () => {
        dispatch(topicSlice.actions.SET_ERR_MSG(""));
        props.onClose();
    }

    return (
        <Dialog open={props.show}
            maxWidth={false} scroll="paper"
            onClose={onClose}
            classes={{ paper: "topic-dialog" }}>
            <DialogTitle className="topic-dialog-title">
                <Typography noWrap className='.dialog-title'>
                    {`Move ${props.toMove}`}
                </Typography>
                <div className="topic-dialog-actions">
                    <IconButton onClick={onClose} size="medium">
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent className='dialog-content'>

                <Grid container
                    alignItems={"center"}
                    paddingTop={DIALOG_BODY_PADDING}
                    paddingBottom={DIALOG_BODY_PADDING}
                >
                    <MandatoryField
                        fieldName="To topic group"
                        fieldInput={getSearchField()} />
                </Grid>

            </DialogContent>

            <DialogActions className="topic-dialog-footer">
                <Button variant="text" onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!selectedGroupId || errorMessage !== ""}
                    onClick={handleMove}
                >
                    Move
                </Button>
            </DialogActions>
        </Dialog>
    );
};

interface ComponentProps {
    toMove: string,
    topics: string[],
    show: boolean,
    onClose: () => void,
}

export default TopicMove;